import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {AuthenticationService} from '../services/authentication.service';

@Directive({
  selector: '[notAllowedPermissions]'
})
export class NotAllowedPermissionsDirective {

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              public authenticationService: AuthenticationService) {
    this.authenticationService.authenticationEvents$.subscribe(
      () => {
        this.setNotAllowerPermissions(this.notAllowedPermissionsArray);
      }
    );
  }

  @Input()
  set notAllowedPermissions(notAllowedPermission: Array<string>) {
    this.notAllowedPermissionsArray = notAllowedPermission;
    this.setNotAllowerPermissions(notAllowedPermission);
  }

  private notAllowedPermissionsArray = [];
  private hasView = false;
  private renderedUser: string = null;

  private setNotAllowerPermissions(notAllowedPermission: Array<string>) {
    const show = this.authenticationService.userHasOneOfThosePermissions(notAllowedPermission) === false;
    const user = this.userFingerprint(this.authenticationService.getUserCurrent());
    if (this.hasView && (!show || user !== this.renderedUser)) {
      this.viewContainer.clear();
      this.hasView = false;
    }
    if (show && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
      this.renderedUser = user;
    }
  }

  private userFingerprint(user): string {
    if (!user) {
      return null;
    }
    const {loadedFrom, ...data} = user;
    return JSON.stringify(data, (key, value) => value && typeof value === 'object' && !Array.isArray(value)
      ? Object.keys(value).sort().reduce((sorted, name) => ({...sorted, [name]: value[name]}), {})
      : value);
  }

}
